import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppResponse, IPagedResult } from '../../_models/network-response';
import { IAppManagementEntityDto } from './app-management.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AppManagementService {

  private endpoint = "app-management";

  constructor(private apiService: ApiService) { }

  getApps(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.get<IPagedResult<IAppManagementEntityDto>>({
      Url: `${this.endpoint}`,
      Params: params
    });
  }

  getAllApps() {
    return this.apiService.get<IAppManagementEntityDto[]>({
      Url: `${this.endpoint}/all`,
    });
  }

  getAppById(id: number) {
    return this.apiService.get<IAppManagementEntityDto>({
      Url: `${this.endpoint}/${id}`,
    });
  }

  createApp(appData: any) {
    return this.apiService.post<object, IAppManagementEntityDto>({
      Url: `${this.endpoint}`,
      Body: appData
    });
  }

  updateApp(jobId: string, job: IAppManagementEntityDto) {
    return this.apiService.put<object, IAppManagementEntityDto>({
      Url: `${this.endpoint}/${jobId}`,
      Body: job
    });
  }

  deleteApp(id: string) {
    return this.apiService.delete<object, object>({
      Url: `${this.endpoint}/${id}`,
      Body: {}
    });
  }

  clearCached() {
    return this.apiService.get({
      Url: `${this.endpoint}/clear-cache-all`
    })
  }
}
